

export class EngagementsUtil {
	// Check if the associatedPortfolios contain already the engagement portfolios (they're readonly so no need ever to reload)
	public static areUpdatedEngagementsInAssociatedPortfolios(engagement, associatedPortfolios, modelsConfigEntities): boolean {
		return engagement?.children?.every(engagementPortfolio => {
			// if the portfolio is a model portfolio and the portkey is in the config then use portkey as the id else use uniqueID
			const id = EngagementsUtil.getEngagementPortfolioId(engagementPortfolio, modelsConfigEntities);
			return associatedPortfolios.entities[id];
		});
	}

	public static getEngagementPortfolioId(engagementPortfolio, modelsConfigEntities): string {
		return this.isModel(engagementPortfolio, modelsConfigEntities) ? engagementPortfolio.portKey : engagementPortfolio.uniqueId;
	}

	public static isModel(engagementPortfolio, modelsConfigEntities): boolean {
		return modelsConfigEntities?.hasOwnProperty(engagementPortfolio?.portKey) || modelsConfigEntities?.hasOwnProperty(engagementPortfolio?.aladdinPortfolioCode);
	}

	public static getEngagementModelApcId(portKey: string, modelsConfigEntities: any): string {
		const modelObject = Object.values(modelsConfigEntities)
			.find(modelConfig => modelConfig['dasPortfolioId'] === portKey || modelConfig['aladdinPortfolioCode'] === portKey);
		return modelObject?.['aladdinPortfolioCode'] || portKey;
	}
}
